<section class="aarni-font w-full pt-[350px] pb-[50px] object-cover md:block hidden mt-[80px]"
         style="background: url('./assets/img/internal-banner-campus-life/it-campus-life.webp'); background-size: cover">
    <div class="container mx-auto px-4">
        <h1 class="uppercase text-center md:text-start font-bold text-white text-[32px] shadow">
            it services
        </h1>
    </div>
</section>
<section class="aarni-font w-full pt-[350px] pb-[50px] object-cover md:hidden mt-[80px]"
         style="background: url('./assets/img/internal-banner-campus-life/campus-life-mobile/it-campus-life.webp'); background-size: cover">
    <div class="container mx-auto px-4">
        <h1 class="uppercase text-center md:text-start font-bold text-white text-[32px] shadow">
            it services
        </h1>
    </div>
</section>


<section class="aarni-font">
    <div class="container mx-auto flex flex-col lg:flex-row gap-8 py-12 px-4">
        <aside class="w-full lg:w-1/4 space-y-4 h-fit overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">IT Services</h2>
                    <div class="">
                        <div (click)="selectSection('About IT Services')"
                             [ngClass]="{'text-white bg-blue-600' : sectionTitle === 'About IT Services', 'text-blue-600 bg-white' : sectionTitle !== 'About IT Services'}"
                             class="flex items-center space-x-2 p-3 w-full border-y border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>About IT Services</span>
                        </div>
                        <div (click)="selectSection('IT Help Desk Support')"
                             [ngClass]="{'text-white bg-blue-600' : sectionTitle === 'IT Help Desk Support', 'text-blue-600 bg-white' : sectionTitle !== 'IT Help Desk Support'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>IT Help Desk Support</span>
                        </div>
                        <div (click)="selectSection('Wi-Fi Registration Process')"
                             [ngClass]="{'text-white bg-blue-600' : sectionTitle === 'Wi-Fi Registration Process', 'text-blue-600 bg-white' : sectionTitle !== 'Wi-Fi Registration Process'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Wi-Fi Registration Process</span>
                        </div>
                        <div (click)="selectSection('How to Access Campus Wi-Fi')"
                             [ngClass]="{'text-white bg-blue-600' : sectionTitle === 'How to Access Campus Wi-Fi', 'text-blue-600 bg-white' : sectionTitle !== 'How to Access Campus Wi-Fi'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>How to Access Campus Wi-Fi</span>
                        </div>
                        <div (click)="selectSection('WiFi')"
                             [ngClass]="{'text-white bg-blue-600' : sectionTitle === 'WiFi', 'text-blue-600 bg-white' : sectionTitle !== 'Wi-Fi_AARNI'}"
                             class="flex items-center space-x-2 p-3 w-full border-b border-gray-300 hover:bg-blue-400 hover:text-white hover:border-blue-400 transition duration-300 cursor-pointer"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>WiFi</span>
                        </div>
                    </div>
                </div>
            </div>
        </aside>
        <div class="flex-1 text-justify">
            <div class="p-12 shadow-lg border-gray-200 bg-white h-fit border">
                <h3 class="font-semibold text-[22px]">
                    {{ sectionTitle }}
                </h3>
                <div *ngIf="sectionTitle === 'About IT Services'">
                    <p class="text-[14px] mt-8">
                        Arni University has a highly professional and systematic IT support and service delivery system
                        to ensure seamless technology operations across the campus. The IT Service Department is
                        committed to providing timely assistance to students, faculty, and staff. A team of trained
                        network and system administrators ensures that users’ laptops, desktops, and networks remain
                        fully operational.

                        Our IT services follow a structured and policy-driven approach, covering the design, planning,
                        delivery, operation, and control of IT infrastructure. Task assignments to support engineers are
                        managed based on SLAs, engineer availability, and skill sets, ensuring swift resolutions. User
                        satisfaction is our top priority.

                        The IT department also manages Data Center Operations and 24/7 internet bandwidth distribution,
                        with a strategically planned network layout using both fiber and copper connections for optimal
                        connectivity. A campus-wide Wi-Fi network is designed to provide seamless access for all users.

                        For IT support, a Helpdesk system is in place, allowing users to request assistance via phone or
                        email. A dedicated team of 18 skilled professionals is deployed across the university to ensure
                        efficient and prompt IT service delivery.
                    </p>
                </div>
                <div *ngIf="sectionTitle === 'IT Help Desk Support'">
                    <p class="text-[14px] mt-8">
                        For any IT related inconvenience you can contact us
                        through any of the following channels.
                    </p>
                    <div class="flex flex-col md:flex-row justify-center mt-16 gap-6 lg:gap-12">
                        <div class="text-center text-wrap">
                            <div
                                class="w-[90px] h-[90px] rounded-full border-gold flex items-center justify-center m-auto">
                                <i class="fa-regular fa-envelope text-gold text-[40px]"></i>
                            </div>
                            <p class="font-semibold text-gray-600 mt-4">MAIL</p>
                            <p class="text-[12px] text-gray-500">
                                Register your issue by
                            </p>
                            <p class="text-[12px] text-gray-500">Email on IT Help Desk</p>
                            <p class="text-[12px] text-blue-500">info@arniuniversity.edu.in</p>
                        </div>
                        <div class="text-center text-wrap">
                            <div
                                class="w-[90px] h-[90px] rounded-full border-gold flex items-center justify-center m-auto">
                                <i class="fa-solid fa-phone text-gold text-[30px]"></i>
                            </div>
                            <p class="font-semibold text-gray-600 mt-4">CALL</p>
                            <p class="text-[12px] text-gray-500">
                                Call on Help Desk
                            </p>
                            <p class="text-[12px] text-gray-500">Ext. Number +91-18008918962</p>
                            <p class="text-[12px] text-blue-500">info@arniuniversity.edu.in</p>
                        </div>
                        <div class="text-center text-wrap">
                            <div
                                class="w-[90px] h-[90px] rounded-full border-gold flex items-center justify-center m-auto">
                                <i class="fa-solid fa-location-dot text-gold text-[30px]"></i>
                            </div>
                            <p class="font-semibold text-gray-600 mt-4">VISIT</p>
                            <p class="text-[12px] text-gray-500">
                                Arni University, (Kathgarh),Tehsil Indora, Distt.
                            </p>
                            <p class="text-[12px] text-gray-500">Kangra,Himachal Pradesh Pin-176401.</p>
                        </div>
                    </div>
                </div>

                <div *ngIf="sectionTitle === 'How to Access Campus Wi-Fi'">
                    <h6 class="text-[18px] font-semibold mt-8 text-gray-600">
                        Access internet
                    </h6>
                    <div class="px-2">
                        <p class="text-[14px] mt-3">
                            <i class="fa-solid fa-check text-gold mr-4"></i> Connect with WIFI_ARNI SSID.
                        </p>
                        <p class="text-[14px] mt-1">
                            <i class="fa-solid fa-check text-gold mr-4"></i> Wi-Fi login page will pop-up now.
                        </p>
                        <p class="text-[14px] mt-1">
                            <i class="fa-solid fa-check text-gold mr-4"></i> Enter the Wi-Fi login credentials shared on
                            email to login on Wi-Fi login form.
                        </p>
                    </div>

                    <h6 class="text-[18px] font-semibold mt-8 text-gray-600">
                        Reset Password
                    </h6>
                    <div class="px-2">
                        <p class="text-[14px] mt-3">
                            <i class="fa-solid fa-check text-gold mr-4"></i> Any user initiates a password reset
                            request; they will be asked to provide their registered mobile number.
                        </p>
                        <p class="text-[14px] mt-1">
                            <i class="fa-solid fa-check text-gold mr-4"></i> An OTP will be sent to the user's mobile
                            number for verification purposes.
                        </p>
                        <p class="text-[14px] mt-1">
                            <i class="fa-solid fa-check text-gold mr-4"></i> After successfully verifying the OTP, the
                            user will be allowed to reset their password securely.
                        </p>
                    </div>
                </div>

                <div *ngIf="sectionTitle === 'Wi-Fi Registration Process'">
                    <p class="text-[14px] mt-8">
                        The Mandatory Requirements For Wi-Fi Registration
                    </p>
                    <div class="w-full overflow-hidden mt-8">
                        <img src="./assets/img/wi-fi.jpeg" class="w-full h-auto" alt="Wi-Fi">
                    </div>
                    <div class="flex mt-10">
                        <div
                            class="w-[40px] h-[40px] rounded-full shadow-lg bg-primary-dark text-white flex justify-center items-center text-[20px] flex-shrink-0">
                            1
                        </div>
                        <div class="ps-4">
                            <p class="font-semibold text-gray-700">
                                SYSTEM ID / EMPLOYEE ID
                            </p>
                            <p class="text-[14px] mt-2">
                                Each student and employee in Arni Campus is identified by his/her unique ID. The
                                10-digit student ID is provided by the Admissions cell to the students and the 7-digit
                                Employee ID is provided by the HR to the staff.
                            </p>
                        </div>
                    </div>
                    <div class="flex mt-10">
                        <div
                            class="w-[40px] h-[40px] rounded-full shadow-lg bg-primary-dark text-white flex justify-center items-center text-[20px] flex-shrink-0">
                            2
                        </div>
                        <div class="ps-4">
                            <p class="font-semibold text-gray-700">
                                User Creation
                            </p>
                            <p class="text-[14px] mt-2">
                                IT-Services create User ID and Password and share the credentials with the students and
                                employee via email.
                            </p>
                        </div>
                    </div>
                    <div class="flex mt-10">
                        <div
                            class="w-[40px] h-[40px] rounded-full shadow-lg bg-primary-dark text-white flex justify-center items-center text-[20px] flex-shrink-0">
                            3
                        </div>
                        <div class="ps-4">
                            <p class="font-semibold text-gray-700">
                                Password Reset
                            </p>
                            <p class="text-[14px] mt-2">
                                Forget password option is available to generate the new password.
                            </p>
                        </div>
                    </div>
                </div>

                <div *ngIf="sectionTitle === 'WiFi'">
                    <p class="text-[12px] mt-6">
                        Need help with your IT Related Issue?
                    </p>
                    <p class="text-[14px] mt-4">
                        Our customer support team is standing by to answer any questions you might have!
                        Contact us at <span class="text-blue-500">info@arniuniversity.edu.in</span> or call at
                        +91-18008918962.
                    </p>

                    <div class="text-wrap w-fit text-center mt-8">
                        <div
                            class="w-[90px] h-[90px] rounded-full border-gold flex items-center justify-center m-auto">
                            <i class="fa-regular fa-envelope text-gold text-[40px]"></i>
                        </div>
                        <p class="font-semibold text-gray-600 mt-4">MAIL</p>
                        <p class="text-[12px] text-gray-500">
                            Register your issue by
                        </p>
                        <p class="text-[12px] text-gray-500">Email on IT Help Desk</p>
                        <p class="text-[12px] text-blue-500">info@arniuniversity.edu.in</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</section>
